import { slicks } from './wc_block_scripts.js';
import { init_variation, init_product_info } from './wc-product.js';
import filter_wrap from './wc_product_filters.js';
import quantity_btn_functionality from './wc_product_quantity.js';
import wc_sorting from './wc_sorting.js';
import wc_quantity_buttons from './wc_quantity_buttons.js';
import wc_cart from './wc_cart_page.js';

export default function heimdall_wc() {
  slicks();
  filter_wrap();
  quantity_btn_functionality();
  init_product_info();
  wc_sorting();
  wc_quantity_buttons();
  wc_cart();

  $('.product-add-to-cart .variations tr').each(function(){
    init_variation(this);
  });

}
